import { cloneDeep, get, reverse } from 'lodash';

export const isEmptyTier = (tier, fieldsForValidation) => (
  !tier || !fieldsForValidation.some(field => get(tier, field))
);

export const getLastNonEmptyTierIdx = (tiers, fieldsForValidation) => {
  const firstNotEmptyFromEnd = reverse([...tiers]).findIndex(item => !isEmptyTier(item, fieldsForValidation));
  if (firstNotEmptyFromEnd === -1) {
    return firstNotEmptyFromEnd;
  }

  return tiers.length - 1 - firstNotEmptyFromEnd;
};

const trimEmptyTiers = (tiers, fieldsForValidation) => {
  const lastFilledIdx = getLastNonEmptyTierIdx(tiers, fieldsForValidation);
  return lastFilledIdx === -1 ? [] : tiers.slice(0, lastFilledIdx + 1);
};

const ensureNumbersInTiers = (tiers, fieldsForValidation) => {
  return tiers.map((tier) => {
    const newTier = { ...tier };
    fieldsForValidation.forEach((field) => {
      newTier[field] = tier[field] || 0;
    });

    return newTier;
  });
};

export const prepareCommissionsForApi = (data) => {
  const clonedData = cloneDeep(data);
  const values = {
    ...clonedData,
    barbers: clonedData.barbers.map(barber => ({
      ...barber,
      barberId: barber.id,
    })),
  };

  values.shop.commissionTiers = trimEmptyTiers(values.shop.commissionTiers, ['amount', 'flatAmount']);
  values.shop.commissionTiers = ensureNumbersInTiers(values.shop.commissionTiers, ['amount', 'flatAmount']);

  values.shop.productCommissionTiers = trimEmptyTiers(values.shop.productCommissionTiers, ['amount', 'flatAmount']);
  values.shop.productCommissionTiers = ensureNumbersInTiers(
    values.shop.productCommissionTiers, ['amount', 'flatAmount']
  );

  values.barbers.forEach((barber, idx) => {
    values.barbers[idx].commissionTiers = trimEmptyTiers(values.barbers[idx].commissionTiers, ['amount', 'percentage']);
    values.barbers[idx].commissionTiers = ensureNumbersInTiers(
      values.barbers[idx].commissionTiers, ['amount', 'percentage']
    );

    values.barbers[idx].productCommissionTiers = (
      trimEmptyTiers(values.barbers[idx].productCommissionTiers, ['amount', 'percentage'])
    );
    values.barbers[idx].productCommissionTiers = (
      ensureNumbersInTiers(values.barbers[idx].productCommissionTiers, ['amount', 'percentage'])
    );
  });

  return values;
};
